// extracted by mini-css-extract-plugin
export default {"PostCreate":"qy_a bik_qt bik_a bik_w bik_ea"};